module.exports = __webpack_public_path__ + "assets/d01291b0a3226e0ab7ade1e9a5bc6d78.mp3";